import { createSelector } from "@reduxjs/toolkit";

import type { SlotId } from "../../schemas/index.ts";
import { getSlotPlaceholderId } from "../querying/index.ts";
import { nodeDesignsByIdSelector, nodeDesignsSlotsByParentIdSelector } from "./nodeDesignsCoreSelectors.ts";
import { slotIdParamSelector } from "./paramSelectors.ts";

export const getSlotPlaceholderIdSelector = createSelector(
  [nodeDesignsByIdSelector, nodeDesignsSlotsByParentIdSelector],
  (designsById, slotsByParentId) => (slotId: SlotId) => getSlotPlaceholderId(designsById, slotsByParentId, slotId),
);

export const slotPlaceholderIdSelector = createSelector(
  [nodeDesignsByIdSelector, nodeDesignsSlotsByParentIdSelector, slotIdParamSelector],
  (designsById, slotsByParentId, slotId) => getSlotPlaceholderId(designsById, slotsByParentId, slotId),
);
